module.exports = __webpack_public_path__ + "img/store-marker.713ae5f6.png";